import { orderBy } from 'lodash-es';
import React, { useEffect, useState } from 'react';

import { EBool } from '~/src/dash/api/types/bool';
import { useBaseStore } from '~/src/dash/views/base/contexts';
import {
  createChannelABTest,
  fetchChannelABTests,
  updateChannelABTest,
} from '~/src/dash/views/channels/api';
import { IChannelABTest } from '~/src/dash/views/channels/api';
import { ChannelABTests } from '~/src/dash/views/channels/ChannelABTests/index';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

interface IChannelABTestsContainer {
  channelID: string;
}

export const ChannelABTestsContainer = ({ channelID }: IChannelABTestsContainer) => {
  const { session } = useBaseStore();

  const [currABTest, setCurrABTest] = useState<IChannelABTest | null>(null);
  const [pastABTests, setPastABTest] = useState<Array<IChannelABTest> | null>(null);
  const [error, setError] = useState<any>(null);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const onFetchTests = () => {
    return fetchChannelABTests(String(session.publisher.ID), channelID)
      .then(({ ChannelABTests }) => {
        setCurrABTest(ChannelABTests.filter((test) => EBool.isTrue(test.Active))[0]);
        setPastABTest(
          orderBy(
            ChannelABTests.filter((test) => !EBool.isTrue(test.Active)),
            (test) => (test.CreatedAt ? new Date(test.CreatedAt) : new Date()),
            'desc',
          ),
        );
      })
      .catch((err) => {
        setError(err);
        setSnackbarMessage('Error retrieving AB tests for the channnel');
      });
  };

  const onCreateTest = (test: IChannelABTest, callback: () => void) => {
    createChannelABTest(session.publisher.ID, test)
      .then(() => {
        onFetchTests();
        callback();
      })
      .catch((err) => {
        setError(err);
        setSnackbarMessage(`Error creating AB test: ${test.Name} for the channnel`);
      });
  };

  const onEndTest = (test: IChannelABTest, callback: () => void) => {
    updateChannelABTest(session.publisher.ID, { ...test, Active: EBool.EBool_FALSE })
      .then(() => {
        onFetchTests();
        callback();
      })
      .catch((err) => {
        setError(err);
        setSnackbarMessage(`Error updating AB test: ${test.Name} for the channnel`);
      });
  };

  const onImplementTestParams = () => {
    // V2 - implement a past test params to the current test
  };

  useEffect(() => {
    onFetchTests();
  }, []);

  return (
    <>
      <ChannelABTests
        currABTest={currABTest}
        pastABTests={pastABTests}
        createTest={onCreateTest}
        endTest={onEndTest}
        implementTestParams={onImplementTestParams}
      />
      <SnackbarView open={!!snackbarMessage} error={error} onClose={() => setSnackbarMessage('')}>
        {snackbarMessage}
      </SnackbarView>
    </>
  );
};
